'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeModal = exports.hideModal = exports.showModal = exports.ActionType = undefined;

var _constants = require('./constants');

var ActionType = exports.ActionType = {
  SHOW: '@react-redux-modal-provider.show',
  HIDE: '@react-redux-modal-provider.hide',
  REMOVE: '@react-redux-modal-provider.remove'
};

var showModal = exports.showModal = function showModal(component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var delayBeforeRemoveMsec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.DELAY_BEFORE_REMOVE_MSEC;

  if (!component) {
    return undefined;
  }

  return {
    type: ActionType.SHOW,
    component: component,
    props: props,
    delayBeforeRemoveMsec: delayBeforeRemoveMsec
  };
};

var hideModal = exports.hideModal = function hideModal(id) {
  return {
    type: ActionType.HIDE,
    id: id
  };
};

var removeModal = exports.removeModal = function removeModal(id) {
  return {
    type: ActionType.REMOVE,
    id: id
  };
};